import script from "./sideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./sideMenu.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__